/**
 * 指定された値が指定された型のいずれかのインスタンスであるかどうかを確認する。
 *
 * @param value 値
 * @param constructors 型
 */
export const assertInstanceOf: <T>(value: unknown, ...constructors: (new (...args: any[]) => T)[]) => asserts value is T = (value, ...constructors) => {
    if (constructors.some((ctor) => value instanceof ctor)) {
        return;
    }

    const ctorNames = constructors.map((c) => c.name).join(" | ");
    throw new TypeError(`Expected instance of ${ctorNames}, got ${value?.constructor?.name ?? typeof value}`);
};
